import React, { useState, useRef, useEffect } from 'react'
import ReactModal from 'react-modal'
import 'react-simple-keyboard/build/css/index.css'
import Keyboard from 'react-simple-keyboard'
import { useTranslation } from 'react-i18next';
import { KEYBOARD_DIALOG } from '../../utils/translation-constants';

export default function KeyboardModal({ children, setText, clearText, closeModel }) {
  const keyboardRef = useRef(null)
  const [layout, setLayout] = useState('default')
  const {t}= useTranslation()

  const handleShift = () => {
    const newLayoutName = layout === 'default' ? 'shift' : 'default'
    setLayout(newLayoutName)
  }

  const onKeyPress = (button) => {
    if (button === '{shift}' || button === '{lock}') handleShift()
  }


  useEffect(() => {
    if (keyboardRef.current !== null) {
      keyboardRef.current.clearInput()
    }
  }, [clearText, keyboardRef])

  return (
    <ReactModal
      isOpen
      style={{
        content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          border: 'none',
          borderRadius: '20px',
          marginRight: '-50%',
          boxShadow: '0 0 10px #AAAAAA',
          transform: 'translate(-50%, -50%)',
        },
      }}>
      <div className='d-flex flex-column text-center p-4'>
        {children}
        <Keyboard
          keyboardRef={(ref) => {
            keyboardRef.current = ref
          }}
          onChange={setText}
          onKeyPress={onKeyPress}
          layoutName={layout}
        />
        <button
          type='button'
          className='mt-2 btn btn-sm btn-link small new-design-warning-text-color font-weight-600'
          onClick={closeModel}>
          {t(KEYBOARD_DIALOG.CLOSE)}
        </button>
      </div>
    </ReactModal>
  )
}
